import React from 'react'
import { Box, Typography } from '@mui/material'
import type { FunMedia } from './types'

const FunMediaPanel = ({ media }: { media: FunMedia }) => {
  return (
    <Box
      sx={{
        mb: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box
        sx={{
          width: 320,
          maxWidth: '100%',
          aspectRatio: '16 / 9',
          borderRadius: 2,
          overflow: 'hidden',
          bgcolor: 'rgba(0,0,0,0.06)',
        }}
      >
        <Box
          component="img"
          src={media.src}
          alt={media.alt}
          loading="lazy"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      </Box>

      <Typography
        variant="body2"
        sx={{
          opacity: 0.9,
          minHeight: 24,
        }}
      >
        {media.caption}
      </Typography>
    </Box>
  )
}

export default FunMediaPanel
